<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">SELEZIONE PROMOZIONI E/O EVENTI</div>
</div>

<!-- Modal body -->
<div class="modal-body">

    <div class="row pt-4 px-4">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="m-3">
                <label for="" class="form-label label-fw">
                    Promozioni/Eventi
                </label>
                <ng-autocomplete #promozioneEventi placeholder="Cerca Promozioni o eventi"
                    [data]="promozioneEventi_Suggestion" [searchKeyword]="promozioneEventi_Keyword"
                    (selected)='selectEvent__promozioneEventi($event)' (inputChanged)='getList_promozioneEventi($event)'
                    (inputFocused)='onFocused__promozioneEventi($event)'
                    (inputCleared)="searchCleared__promozioneEventi()" [itemTemplate]="itemTemplate_promozioneEventi"
                    [notFoundTemplate]="notFoundTemplate_promozioneEventi" [debounceTime]="600"
                    [isLoading]="promozioneEventi_isKeywordLoadingResult" [minQueryLength]="2">
                </ng-autocomplete>
                <ng-template #itemTemplate_promozioneEventi let-item>
                    <div class="col-12">
                        <div class="mx-3">
                            <span [innerHTML]="item.name"></span>
                        </div>
                    </div>
                </ng-template>
                <ng-template #notFoundTemplate_promozioneEventi let-notFound>
                    {{errorMsg_promozioneEventi}}
                </ng-template>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="m-3">
                <fieldset class="fieldset-fw" [hidden]="promozioneEventi_Selected.length === 0">
                    <legend hidden></legend>
                    <app-draggable-list-chip [itemList]="promozioneEventi_Selected"
                        [labelKeys]="labelKeys_promozioneEventi"
                        (changeItemList)="onChangeItemList_promozioneEventi($event)">
                    </app-draggable-list-chip>
                </fieldset>
            </div>
        </div>
    </div>


    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3" [disabled]="isButtonSaveDisabled"
                (click)="clickButtonSave()">Conferma</button>
            <button type="button" class="btn btn-outline-fw text"
                (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>